import React, {useEffect} from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "../../../../../../../ui/Dialog/DialogTitle";
import DialogContent from "../../../../../../../ui/Dialog/DialogContent";
import DialogActions from "../../../../../../../ui/Dialog/DialogActions";
import Button from "../../../../../../../ui/Button";
import TextField from "../../../../../../../ui/TextField";
import {getDictModules} from "../../../../../../../Dict/store/actions";
import {connect} from "react-redux";
import DataSelect from "../../../../../../../ui/DataSelect";
import Alert from '@material-ui/lab/Alert';

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2)
  },
  dialog: {
    width: "550px"
  }
})

const AddModuleDialog = ({ open,
                          handleClose,
                           handleConfirm,
                          isLoading,
                          classes,
                           getDictModules,
                           moduleList
                        }) => {
  const [number, setNumber] = React.useState(null);
  const [module, setModule] = React.useState(null);

  useEffect(() => {
    getDictModules();
  }, []);

  const handleConfirmModule = () => {
    const data = {
      number: number,
      moduleId: module
    };
    handleConfirm && handleConfirm(data);
    handleClose();
  };

  return (
    <div>
      <Dialog onClose={handleClose}
              aria-labelledby="customized-dialog-title"
              open={open}
              PaperProps={{
                className: classes.dialog
              }}>
        <div>
          <DialogTitle>Добавить модуль</DialogTitle>
          <DialogContent>

            {(!moduleList || moduleList.length == 0) &&
            <Alert severity="warning">На платформе отсутствуют опубликованные модули.</Alert>}

            <Grid container spacing={1}>
              <Grid item xs={2}>
                <TextField
                  required
                  label="Номер"
                  value={number}
                  disabled={!moduleList || moduleList.length == 0}
                  onChange={(e) => setNumber(e.target.value)}
                />
              </Grid>
              <Grid item xs={10}>
                {moduleList &&
                <DataSelect
                  required
                  value={module}
                  onChange={value => setModule(value._key)}
                  label="Модули"
                  disabled={!moduleList || moduleList.length == 0}
                  dataSource={moduleList}
                  keyField="_key"
                />}
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions>
            <Button onClick={handleClose}>Отмена</Button>
            <Button
              onClick={() => handleConfirmModule()}
              color="green"
              disabled={!moduleList || moduleList.length == 0}>
              Добавить
            </Button>
          </DialogActions>
        </div>
      </Dialog>
    </div>
  );
}

const mapStateToProps = state => ({
  moduleList: state.dictAll.moduleList
});

const mapDispatchToProps = dispatch => ({
  getDictModules: () => dispatch(getDictModules())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(AddModuleDialog));
